// src/components/IncomingOrders/helpers/addressUtils.js

export const addressObjectMap = Object.freeze({
  deliveryAddress: "deliveryAddress",
  invoiceAddress: "invoiceAddress",
  ordererAddress: "ordererAddress",
});

export const ADDRESS_FIELDS = [
  "CustomerId",
  "Address1",
  "Address2",
  "Address3",
  "Address4",
  "Address5",
  "City",
  "Zip",
  "Country",
  "Reference",
  "Email",
  "Telephone",
  "Contact",
];

const validAddressFields = new Set(ADDRESS_FIELDS);

const handleError = (message) => {
  const isDevLike = process.env.NODE_ENV !== "production";

  if (isDevLike) {
    throw new Error(message);
  } else {
    console.error(message);
    return null;
  }
};

const getBasePath = (editType) => {

  
  const basePath = addressObjectMap[editType];

  if (!basePath) {

    debugger;
    handleError(`Invalid editType: "${String(editType)}". Valid types: ${Object.keys(addressObjectMap).join(", ")}`);
    return null;
  }

  return basePath;
};

export const hasStringValue = (value) => {
  if (typeof value !== "string") return false;
  return value.trim().length > 0;
}

export const getAddressObjectName = (editType) => {
  return getBasePath(editType);
};

export const createAddressFieldPath = (editType, field) => {
  const basePath = getBasePath(editType);

  if (basePath == null) return null;

  // allow composite rowId
  const isComposite = field.includes("__");

  if (!isComposite && !validAddressFields.has(field)) {
    debugger;
    handleError(`Invalid address field: "${String(field)}"`);
    return null;
  }

  return `${basePath}.${field}`;
};

export function normalizeAddress(addr) {
  if (!addr) return {};

  const clean = {};

  Object.entries(addr).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key.startsWith("__")) return;
    clean[key] = value;
  });

  return clean;
};
